import React from "react";
import "./Heading.css"

const Heading = () => {
    const head = "Choice Predicting App"

    return (
        <div className="heading_div">
        <h1>{head}</h1>
        </div>
    )
};

export default Heading;